import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { gettingStates } from "../../../function/other";
import { CreditNoteContext } from "../../../pages/main/credit note/add update note";
import InputDateForm from "../../../shared components/DateInput/InputDateForm";
import DropdownOne from "../../../shared components/Dropdown/DropdownOne";
import DropdownTwo from "../../../shared components/Dropdown/DropdownTwo";
import InputError from "../../../shared components/InputError/InputError";
import { noteReasonMap } from "../../../utils/constants";
import { AiOutlineReload } from "react-icons/ai";
import { MainContext } from "../../../utils/private_routes/PrivateRoutes";

const Form = () => {
  const { documentSetting } = useContext(MainContext);
  const {
    creditNoteId,
    loading,
    formik,
    clientList,
    invoiceList,
    clientloading,
    invoiceloading,
    getDocNumber,
  } = useContext(CreditNoteContext);

  const [states, setStates] = useState<string[]>([]);

  useEffect(() => {
    setStates(gettingStates("IN"));
  }, []);

  return (
    <>
      <div className="container-fluid px-4">
        <div
          className="row py-2"
          style={{
            backgroundColor: "var(--bg_color5)",
            borderRadius: "8px",
          }}
        >
          <div className="col-12 col-lg-6">
            <div className="mb-3">
              <DropdownTwo
                label="Client Name*"
                placeholder="Select client"
                name="clientName"
                data={clientList}
                state={formik.values.clientName}
                setState={(e?: string, x?: string | number) => {
                  formik.setFieldValue("clientName", e);
                  formik.setFieldValue("client", x);
                }}
                isDisabled={creditNoteId ? true : false}
                labelField="name"
                onBlur={() => formik.setFieldTouched("clientName", true)}
              />
              {formik.touched.clientName && formik.errors.clientName ? (
                <InputError error={formik.errors.clientName} />
              ) : null}
            </div>

            {clientloading ? (
              <Skeleton width="120px" borderRadius={4} />
            ) : (
              formik.values.placeOfSupply && (
                <>
                  <div>
                    <p className="mb-0 font12x400 textColor3">
                      <span className="font12x600 textColor3">GSTIN: </span>
                      {formik.values.gstNo}
                    </p>
                  </div>

                  <div className="my-3">
                    <DropdownOne
                      label="Place of Supply*"
                      placeholder="Place of supply"
                      name="placeOfSupply"
                      data={states}
                      state={formik.values.placeOfSupply}
                      setState={(e?: string, x?: string | number) => {
                        formik.setFieldValue("placeOfSupply", e);
                      }}
                      onBlur={() =>
                        formik.setFieldTouched("placeOfSupply", true)
                      }
                    />
                    {formik.touched.placeOfSupply &&
                    formik.errors.placeOfSupply ? (
                      <InputError error={formik.errors.placeOfSupply} />
                    ) : null}
                  </div>
                </>
              )
            )}
          </div>
          <div className="col-12 col-lg-6">
            {clientloading ? (
              <Skeleton width="200px" borderRadius={4} />
            ) : (
              formik.values.clientAddress && (
                <div>
                  <p className="mb-0 font12x600 textColor3 mb-0 mb-lg-2">
                    Billing Address:
                  </p>
                  <p className="mb-0 font12x400 textColor3">
                    {clientloading ? (
                      <Skeleton width="200px" borderRadius={4} />
                    ) : (
                      formik.values.clientAddress
                    )}
                  </p>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      <div className="container-fluid mt-3 px-3">
        <div className="row">
          <div className="mb-3 col-12 col-lg-6">
            <label
              htmlFor="creditNoteNumber"
              className="form-label font12x400 textColor3 mb-1"
            >
              Credit Note No*
            </label>
            <div className="input-group">
              {!creditNoteId && (
                <div className="input-group-text font12x600 border-0">
                  {documentSetting?.creditNote?.initials !== ""
                    ? `${documentSetting?.creditNote?.initials}/`
                    : ""}
                </div>
              )}
              <input
                type="text"
                className="form-control shadow-none font12x600 border-0"
                id="creditNoteNumber"
                value={formik.values.creditNoteNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={creditNoteId ? true : false}
                style={{
                  cursor: creditNoteId ? "no-drop" : "unset",
                  backgroundColor: creditNoteId ? "#f2f2f2" : "#fff",
                  color: creditNoteId ? "#9C9E9C" : "var(--text3)",
                }}
              />
            </div>
            <div className="d-flex justify-content-between align-items-center">
              {formik.touched.creditNoteNumber &&
              formik.errors.creditNoteNumber ? (
                <InputError error={formik.errors.creditNoteNumber} />
              ) : null}
              {formik.touched.creditNoteNumber &&
              formik.errors.creditNoteNumber ? (
                <AiOutlineReload
                  className="cursor_pointer"
                  onClick={() => getDocNumber({ f: "creditNote" })}
                />
              ) : null}
            </div>
          </div>

          <div className="mb-3 col-12 col-lg-6">
            <InputDateForm
              id="creditNoteDate"
              label="Credit Note Date*"
              type="date"
              state={moment(formik.values.creditNoteDate).format("YYYY-MM-DD")}
              setState={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.creditNoteDate && formik.errors.creditNoteDate ? (
              <InputError error={formik.errors.creditNoteDate} />
            ) : null}
          </div>
        </div>
        <div className="row">
          <div className="mb-3 col-12 col-lg-6">
            <DropdownTwo
              label="Invoice No*"
              placeholder="Select invoice no"
              name="invoiceNumber"
              data={invoiceList}
              state={formik.values.invoiceNumber}
              setState={(e?: string, x?: string | number) => {
                formik.setFieldValue("invoiceNumber", e);
                formik.setFieldValue("invoice", x);
              }}
              isDisabled={creditNoteId ? true : false}
              labelField="invoiceNumber"
              onBlur={() => formik.setFieldTouched("invoiceNumber", true)}
            />
            {formik.touched.invoiceNumber && formik.errors.invoiceNumber ? (
              <InputError error={formik.errors.invoiceNumber} />
            ) : null}
          </div>

          <div className="mb-3 col-12 col-lg-6">
            <DropdownOne
              label="Reason*"
              placeholder="Select reason"
              name="reason"
              data={noteReasonMap}
              state={formik.values.reason}
              setState={(e?: string, x?: string | number) => {
                formik.setFieldValue("reason", e);
              }}
              onBlur={() => formik.setFieldTouched("reason", true)}
            />
            {formik.touched.reason && formik.errors.reason ? (
              <InputError error={formik.errors.reason} />
            ) : null}
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-6">
            <label className="form-label font12x400 textColor3 mb-1">
              Invoice Date*
            </label>
            <p className="mb-0 font12x600 textColor3">
              {invoiceloading ? (
                <Skeleton width="80px" borderRadius={4} />
              ) : (
                <>
                  {formik.values.invoiceDate
                    ? formik.values.invoiceDate
                    : "DD-MM-YYYY"}
                </>
              )}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Form;
